<template>
  <div @click="onClick" :id="ques.index" class="question" :class="{'analysis':hasAnalysis}">
    <div class="icon-result icon-right" v-if="ques.is_right==1&&hasAnalysis&&ques.ques_type!=5">
      <i class="el-icon-check bold"></i>
    </div>
    <div
      class="icon-result icon-error"
      v-else-if="ques.is_right!=1&&hasAnalysis&&ques.ques_type!=5"
    >
      <i class="el-icon-close bold"></i>
    </div>
    <div class="stem bold" :class="'stem'+ques.ques_type.toString()">
      <div class="num-type" v-if="ques.ques_type!=5">
        <span>{{ques.index}}.(</span>
        <span class="type">{{ques.ques_type_name}}</span>)
      </div>
      <div class="num-type" v-else>
        <span>{{ques.index}}.</span>
        <span class="type">{{ques.ques_type_name}}</span>
        <span>{{'（'+ques.score+"分）"}}</span>
      </div>
      <div class="rich-text" v-html="ques.ques_stem" v-if="ques.ques_type!=5"></div>
    </div>
    <div class="rich-text stem5" v-if="ques.ques_type==5" v-html="ques.ques_stem"></div>
    <div class="options">
      <el-radio-group
        v-model="answer[ques.id]"
        v-if="ques.ques_type==1||ques.ques_type==3"
        @change="onChange(ques)"
        :disabled="readonly"
      >
        <el-radio :label="option.id" v-for="(option,index) in ques.ques_option" :key="option.id">
          <div class="option">
            <span>{{chars[index+1]}}、</span>
            <div class="rich-text">
              <div v-html="option.content"></div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </el-radio>
      </el-radio-group>
      <el-checkbox-group
        v-model="answer[ques.id]"
        v-else-if="ques.ques_type==2"
        @change="onChange(ques)"
        :disabled="readonly"
      >
        <el-checkbox v-for="(option,index) in ques.ques_option" :label="option.id" :key="option.id">
          <div class="option">
            <span>{{chars[index+1]}}、</span>
            <div class="rich-text">
              <div v-html="option.content"></div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </el-checkbox>
      </el-checkbox-group>
      <div class="line" v-else-if="ques.ques_type==4">
        <div>
          <div class="line-title">题目</div>
          <div
            class="option"
            v-for="(leftOption,index) in ques.ques_option.left"
            :key="leftOption.id"
          >
            <div class="stem">
              <span>{{index+1}})</span>
              <span v-html="leftOption.content"></span>
            </div>
            <div class="answer">
              <span>答案</span>
              <el-radio-group v-model="answer[ques.id][leftOption.id]" :disabled="readonly">
                <el-radio
                  :label="rightOption.id"
                  v-for="rightOption in ques.ques_option.right"
                  :key="rightOption.id"
                  @change="onChange(ques)"
                >{{chars[rightOption.id]}}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="line-title">选项</div>
          <div class="option" v-for="rightOption in ques.ques_option.right" :key="rightOption.id">
            <div class="num">选项{{chars[rightOption.id]}}</div>
            <div v-html="rightOption.content"></div>
          </div>
        </div>
      </div>
      <Editor
        v-else-if="ques.ques_type==5&&!readonly"
        :content.sync="answer[ques.id]"
        uploadUrl="/api/app/public/file"
      ></Editor>
    </div>
    <div class="analysis clear" :class="'analysis'+ques.ques_type.toString()" v-if="hasAnalysis">
      <div class="answer clear" v-if="ques.ques_type!=5">
        <div class="f-left">
          <span>
            <span>正确答案：</span>
            <span class="primary-color">{{ques.answer}}</span>
          </span>
          <span class="user">
            <span>您的答案：</span>
            <span class="primary-color">{{ques.user_answer_label||ques.user_answer}}</span>
          </span>
        </div>
        <div class="f-right operate" v-if="showOperate">
          <div class="f-left" @click.stop="collect" v-if="ques.collect_id>0">
            <img src="../images/exam/point/collect-has@3x.png" style="width:17px;" />
            <span class="primary-color">取消收藏</span>
          </div>
          <div class="f-left" @click.stop="collect" v-else>
            <img src="../images/exam/point/collect@2x.png" style="width:17px;" />
            <span>收藏</span>
          </div>
          <div class="f-right" @click.stop="showCorrection=true">
            <img src="../images/exam/point/hand@2x.png" style="width:15px;" />
            <span>纠错</span>
          </div>
        </div>
      </div>
      <div class="subjective-answer" v-else-if="ques.ques_type==5&&readonly">
        <div>您的答案：</div>
        <div
          v-if="ques.user_answer.length>0"
          v-html="(ques.user_answer_label||ques.user_answer)[0]['id']"
        ></div>
      </div>
      <div
        class="subjective-answer"
        v-if="ques.ques_type==5&&ques.review_status==1"
        style="padding-top:24px;"
      >
        <div>您的得分：</div>
        <div>{{ques.user_score}}</div>
      </div>
      <div class="detail">
        <div>
          <label>考&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;点：</label>
          <span class="point" v-for="(p,index) in points" :key="index">{{p}}</span>
          <span v-if="points.length==0">暂无考点</span>
        </div>
        <div class="analysis-detail">
          <label>题目解析：</label>
          <div v-html="ques.ques_analysis" v-if="ques.ques_analysis"></div>
          <div v-else>暂无解析</div>
        </div>
      </div>
    </div>
    <el-dialog title="纠错" :visible.sync="showCorrection" width="644px" :center="true">
      <div class="form-item">
        <label>纠错类型：</label>
        <el-radio-group v-model="correction.type">
          <el-radio :label="1">错别字</el-radio>
          <el-radio :label="2">答案解析不匹配</el-radio>
          <el-radio :label="3">解析错误</el-radio>
          <el-radio :label="4">其他</el-radio>
        </el-radio-group>
      </div>
      <div class="form-item">
        <label>纠错内容：</label>
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入题目纠错信息，最多不超过500个字"
          v-model="correction.error_msg"
          :maxlength="500"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="showCorrection = false">取消</el-button>
        <el-button type="primary" @click="submitCorrection">提交</el-button>
      </span>
    </el-dialog>
    <ImageViewer :isShow.sync="showImageViewer" :images="images"></ImageViewer>
  </div>
</template>
<script>
import ImageViewer from "@/components/ImageViewer.vue";
import Editor from "@/components/Editor.vue";

export default {
  name: "ExamQuestion",
  components: { ImageViewer, Editor },
  props: {
    ques: {
      type: Object
    },
    answer: {
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hasAnalysis: {
      type: Boolean,
      default: false
    },
    showOperate: {
      type: Boolean,
      default: false
    },
    showScore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chars: { 1: "A", 2: "B", 3: "C", 4: "D", 5: "E", 6: "F" },
      points: [],
      showCorrection: false,
      correction: {
        type: "",
        error_msg: ""
      },
      images: [],
      showImageViewer: false
    };
  },
  created() {
    let point = this.ques.point_name || this.ques.point;
    let points;
    if (point) {
      points = point.split(",");
    } else {
      points = [];
    }
    this.points = points;
  },
  watch: {
    answer: {
      deep: true,
      handler: function() {
        this.onChange(this.ques);
      }
    }
  },
  methods: {
    onChange(ques) {
      this.$emit("change", ques);
    },
    async submitCorrection() {
      if (this.correction.type === "") {
        this.$info("请选择纠错类型");
        return;
      }
      if (this.correction.error_msg === "") {
        this.$info("请输入纠错内容");
        return;
      }
      await this.$http.post("/api/app/myExam/correction", {
        ques_id: this.ques.id,
        type: this.correction.type,
        error_msg: this.correction.error_msg
      });
      this.showCorrection = false;
      this.$success("提交成功");
    },
    async collect() {
      if (this.ques.collect_id > 0) {
        await this.$http.put(
          "/api/app/collect/cancel/" + this.ques.collect_id + "/3"
        );
        this.ques.collect_id = null;
        this.$success("取消收藏成功");
      } else {
        this.ques.collect_id = await this.$http.post("/api/app/collect", {
          ques_id: this.ques.id,
          type: 3
        });
        this.$success("收藏成功");
      }
    },
    onClick(event) {
      let target = event.target;
      if (target.tagName.toLowerCase() == "img") {
        this.images = [target.src];
        this.showImageViewer = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.question {
  padding: 28px;
  border-bottom: 1px solid #e9ecec;
  position: relative;
  &:last-child {
    border-bottom: none;
  }
  &.analysis {
    .options {
      padding-left: 24px;
    }
  }
  .option {
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    display: flex;
  }
  .icon-result {
    position: absolute;
    left: 0;
    top: 100px;
    color: white;
    width: 32px;
    height: 32px;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    font-size: 20px;
    text-align: center;
    line-height: 32px;
  }
  .icon-right {
    background-color: #30c596;
  }
  .icon-error {
    background-color: #ff5400;
  }
  .stem {
    display: flex;
    font-size: 18px;
    color: #333333;
    margin-bottom: 30px;
    &.stem5 {
      margin-bottom: 20px;
    }
    .num-type {
      white-space: nowrap;
    }
    .type {
      color: $primary-color;
    }
    .rich-text {
      margin-left: 5px;
    }
  }
  .rich-text.stem5 {
    margin-bottom: 40px;
  }
  /deep/ .el-radio-group {
    display: flex;
    flex-direction: column;
    .el-radio {
      display: flex;
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  /deep/ .el-checkbox-group {
    display: flex;
    flex-direction: column;
    .el-checkbox {
      display: flex;
      margin-bottom: 30px;
      .el-checkbox__label {
        line-height: 1;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .line {
    display: flex;
    .line-title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    .answer {
      display: flex;
      align-items: center;
      > span:first-child {
        margin-right: 24px;
        white-space: nowrap;
      }
    }
    .option {
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 10px;
      padding: 20px;
      font-size: 16px;
      margin-bottom: 15px;
      display: block;
      .stem {
        display: flex;
        font-size: 16px;
        align-items: center;
        span:first-child {
          margin-right: 15px;
        }
      }
    }
    /deep/ .el-radio-group {
      display: block;
      .el-radio {
        display: inline-block;
        margin-bottom: 0;
      }
    }
    .right {
      margin-left: 15px;
      .option {
        display: flex;
        .num {
          border: 1px solid $primary-color;
          color: $primary-color;
          border-radius: 5px;
          margin-right: 10px;
          width: 78px;
          box-sizing: border-box;
          height: 35px;
          text-align: center;
          line-height: 35px;
          flex: 0 0 auto;
        }
        > div:last-child {
          flex-grow: 1;
        }
      }
    }
    > div {
      flex-grow: 1;
    }
  }
  .analysis {
    padding-top: 60px;
    .answer {
      background-color: #f7f7f7;
      padding: 16px 30px;
      color: #666666;
      .user {
        margin-left: 64px;
      }
    }
    &.analysis5 {
      padding-top: 0;
      .detail {
        padding-left: 0;
      }
    }
    .detail {
      padding: 24px 30px 40px 30px;
      font-size: 16px;
      > div:first-child {
        margin-bottom: 24px;
      }
      label {
        color: #666666;
        margin-right: 12px;
      }
      .point {
        background-color: $primary-color;
        color: white;
        border-radius: 4px;
        padding: 2px 16px;
        margin-right: 10px;
      }
      .analysis-detail {
        display: flex;
        > label {
          white-space: nowrap;
        }
      }
    }
  }
  .operate {
    font-size: 16px;
    color: #595959;
    > div {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 5px;
      }
    }
    .f-left {
      margin-right: 40px;
    }
  }
}
.form-item {
  &:first-child {
    align-items: center;
  }
  /deep/ .el-radio-group {
    display: block;
    .el-radio {
      display: inline-block;
      margin-bottom: 0;
    }
  }
}
.subjective-answer {
  display: flex;
  color: #666666;
  > div:first-child {
    margin-right: 12px;
  }
}
</style>
<style lang="scss">
.analysis-detail img {
  max-width: 100%;
}
</style>